const SET_NUMBER = 'setNumber'

const state = {
  number: null,
}

const getters = {
  state: state => state,
  getNumber: state => state.number,
}

const actions = {
  [SET_NUMBER] ({commit}, number) {
    commit(SET_NUMBER, number)
  }
}

const mutations = {
  [SET_NUMBER] (state, number) {
    state.number = number;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./skins/xkiosk/data/reservation.js